/** Consolidated from identical copies in ./stripe and ./payments-gateway, which now re-export it. */
export enum SubscriptionState {
    NO_SUBSCRIPTION,
    NO_CREDIT_CARD_TRIAL,
    CREDIT_CARD_TRIAL,
    MS_NO_SUBSCRIPTION,
    ACTIVE,
    ACTIVE_WITH_PAYMENT_ERROR,
    CANCELED,
    CHURNED_FROM_PAID,
    LAPSED,
    UNKNOWN,
    ACTIVE_DO_NOT_RENEW
}
